'use client';

import { useTranslationStore } from '@/stores';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import {
  EpStepContent,
  EpStepSelect,
} from '../../../../../components/HookFormComponents/components';
import { useTranslation as t } from '../../../../../hooks/useTranslation';
import { notificationService } from '../../../../../services/notificationService';
import { globalizationService } from '../../../../../services/globalizationService';
function TechnicalComplaintsInput() {
  const NotificationCategory = useWatch({
    name: 'notificationCategoryId.inputValue',
  });

  const { resetField } = useFormContext();
  const { translations } = useTranslationStore();
  const tag = 'PSNotification';
  const { translations: translationPSNotification } =
    globalizationService.getTranslationsByTag(tag);

  const { getNotificationTypesCategoriesTechnicalComplaints } =
    notificationService;

  const {
    data: TechnicalComplaintsOptions,
    isLoading,
    refetch,
  } = getNotificationTypesCategoriesTechnicalComplaints(NotificationCategory);

  useEffect(() => {
    if (NotificationCategory) {
      // resetField('notificationTechnicalComplaintId');
      refetch();
    }
  }, [NotificationCategory, refetch, resetField]);

  if (
    (TechnicalComplaintsOptions?.itens &&
      TechnicalComplaintsOptions?.itens.length === 0) ||
    isLoading
  ) {
    return null;
  }

  return (
    <EpStepContent.Label
      label={t(translationPSNotification, 'Technical claim') + ' *'}
    >
      <EpStepSelect
        data={TechnicalComplaintsOptions?.itens}
        errorMessage={t(translations['global'], '* Required Fied')}
        registerId={'notificationTechnicalComplaintId'}
        required={true}
      />
    </EpStepContent.Label>
  );
}

export default TechnicalComplaintsInput;
